/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	// import { showIndex } from "../include/module";
	// import { anchorLink } from "../include/module";
	//
	//
	// (() => {
	//
	//   showIndex();
	//   anchorLink();
	//
	// })();
	//preload
	(0, _module.preload)(); //checkSP
	
	(0, _module.checkSP)(); //ローディング
	
	(0, _module.showIndex)(); //bgAnime
	
	(0, _module.bgAnime)(); //toggleHeader
	
	(0, _module.toggleHeader)(); //pageTop
	
	(0, _module.pageTop)(); //showMovie
	
	(0, _module.showMovie)(); //showTtl
	
	(0, _module.showTtl)();

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.showTtl = exports.anchorLink = exports.showMovie = exports.pageTop = exports.toggleHeader = exports.bgAnime = exports.showIndex = exports.checkSP = exports.preload = void 0;
	var headerFlag = false;
	var stHeaderNav = document.getElementById('st-Header_Nav');
	var stHeaderBg = document.getElementById('st-Header_Bg');
	var headerButton = document.getElementById('st-Menu');
	var windowW = $(window).width();
	var windowH = $(window).innerHeight();
	var _isSP = false;
	var _isTest = false; // preload
	
	var preload = function preload() {
	  $(window).on('load', function () {
	    $("body").removeClass("preload");
	  });
	}; // checkSP
	
	
	exports.preload = preload;
	
	var checkSP = function checkSP() {
	  $(window).on('resize load', function () {
	    windowW = $(window).width();
	
	    if (windowW <= 767) {
	      _isSP = true;
	    } else {
	      _isSP = false;
	    }
	
	    ;
	  });
	}; // showIndex
	
	
	exports.checkSP = checkSP;
	
	var showIndex = function showIndex() {
	  if (!_isTest) {
	    $(window).on('load', function () {
	      setTimeout(function () {
	        $('#st-Loader_Box_Txt-0').removeClass("hidden");
	      }, 10);
	      setTimeout(function () {
	        $('#st-Loader_Box_Txt-1').removeClass("hidden");
	      }, 300);
	      setTimeout(function () {
	        $('#st-Loader_Box_Star').removeClass("hidden");
	      }, 500);
	      setTimeout(function () {
	        $('#st-Loader_Box').addClass("hidden");
	      }, 2200);
	      setTimeout(function () {
	        $('#st-Loader').addClass("hidden");
	      }, 2500);
	      setTimeout(function () {
	        $('#st-Loader').remove();
	      }, 3000);
	      setTimeout(function () {
	        showVisual();
	      }, 2650);
	    });
	  } else {
	    $('#st-Loader').remove();
	    setTimeout(function () {
	      showVisual();
	    }, 1000);
	  }
	
	  ; //キービジュアル
	
	  function showVisual() {
	    $('.index-Keyvisual_Img_Item').addClass("show");
	    setTimeout(function () {
	      $('.index-Keyvisual_Img_Item').addClass("hidden");
	    }, 500);
	    setTimeout(function () {
	      $('.img-Box').addClass("show");
	    }, 500);
	  }
	
	  ; // $('#st-Loader').stop().animate({'opacity':0}, 500, 'linear', function(){
	  //   $('#st-Loader').remove();
	  //   showMain();
	  // });
	}; // bgAnime
	
	
	exports.showIndex = showIndex;
	
	var bgAnime = function bgAnime() {
	  var bgBox = $("#st-Container_Bg");
	  var positionBg = 0; //初期値を取得
	  //横幅のリサイズだけ検出
	
	  var lastInnerWidth = window.innerWidth;
	  window.addEventListener("resize", function () {
	    // 現在と前回の横幅が違う場合だけ実行
	    if (lastInnerWidth != window.innerWidth) {
	      bgBox.css('top', '');
	      positionBg = 0; //初期値を取得
	      // 横幅を記録しておく
	
	      lastInnerWidth = window.innerWidth;
	    }
	  });
	  $(window).on("scroll load", function () {
	    var value = $(this).scrollTop();
	    var h = $(window).height();
	
	    if (_isSP) {
	      bgBox.css('top', -value / 20);
	    } else {
	      bgBox.css('top', -value / 18);
	    }
	
	    ;
	  });
	}; //toggleHeader
	
	
	exports.bgAnime = bgAnime;
	
	var toggleHeader = function toggleHeader() {
	  headerButton.addEventListener('click', function () {
	    if (!headerFlag) {
	      // $('#st-Header_Navi').css({'display':'block'});
	      setTimeout(function () {
	        stHeaderNav.classList.remove('closed');
	        headerButton.classList.remove('closed');
	        stHeaderBg.classList.remove('closed');
	        stHeaderNav.classList.add('opend');
	        headerButton.classList.add('opend');
	        stHeaderBg.classList.add('opend');
	        headerFlag = true;
	      }, 0);
	    } else {
	      stHeaderNav.classList.remove('opend');
	      headerButton.classList.remove('opend');
	      stHeaderBg.classList.remove('opend');
	      stHeaderNav.classList.add('closed');
	      headerButton.classList.add('closed');
	      stHeaderBg.classList.add('closed');
	      headerFlag = false;
	      setTimeout(function () {// $('#st-Header_Navi').css({'display':'none'});
	      }, 0);
	    }
	  }, false); // スクロールで縮める
	
	  $(window).on("scroll", function () {
	    var scrollPosition = $(window).scrollTop();
	
	    if (scrollPosition >= 70) {
	      $("#st-Header").addClass('st-Header-Shorten');
	    } else {
	      $("#st-Header").removeClass('st-Header-Shorten');
	    }
	  });
	}; //anchorLink
	
	
	exports.toggleHeader = toggleHeader;
	
	var anchorLink = function anchorLink() {
	  //ページ外からのページ内リンク
	  var urlHash = location.hash;
	
	  if (urlHash) {
	    $('body,html').stop().scrollTop(0);
	    setTimeout(function () {
	      var target = $(urlHash);
	      var position = target.offset().top - 80;
	      $('body,html').stop().animate({
	        scrollTop: position
	      }, 500);
	    }, 200);
	  } //ページ内リンク
	
	
	  $("a[href^='#']").on("click", function () {
	    var linkSpeed = 700;
	    var linkHref = $(this).attr("href");
	    var linkTarget = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
	    var linkAdjust = 80;
	    var linkPosition = linkTarget.offset().top;
	    $("html, body").animate({
	      scrollTop: linkPosition - linkAdjust
	    }, linkSpeed, "easeInOutQuint");
	    return false;
	  });
	}; //pageTop
	
	
	exports.anchorLink = anchorLink;
	
	var pageTop = function pageTop() {
	  $(window).on("scroll", function () {
	    var scrollPosition = $(window).scrollTop();
	
	    if (scrollPosition >= 70) {
	      $("#st-Top").removeClass('st-Top-Hidden');
	    } else {
	      $("#st-Top").addClass('st-Top-Hidden');
	    }
	  });
	  $("#st-Top").on("click", function () {
	    var linkSpeed = 700;
	    $("html, body").animate({
	      scrollTop: 0
	    }, linkSpeed, "easeInOutQuint");
	    return false;
	  });
	}; //showMovie
	
	
	exports.pageTop = pageTop;
	
	var showMovie = function showMovie() {
	  var $modal = $('#movie-Stage');
	  var $content = $('#movie-Iframe'); // open
	
	  $('.js-Youtube').on('click', function () {
	    var dataID = $(this).attr('data-youtube');
	    $('#movie-Stage').css({
	      'opacity': '0',
	      'display': 'block'
	    }).stop().animate({
	      'opacity': '1',
	      'width': 100 + '%',
	      'height': 100 + '%',
	      'top': 0,
	      'left': 0
	    }, 300, 'easeOutQuart', function () {
	      //iframe append
	      $content.append('<iframe width="900" height="506" src="https://www.youtube.com/embed/' + dataID + '?rel=0&amp;autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen" frameborder="0"></iframe>'); // fadeIn
	
	      $modal.stop().fadeIn(400);
	      return false;
	    });
	  }); //close
	
	  $('#movie-Close,#movie-Iframe').on('click', function () {
	    $('#movie-Stage').css({
	      'opacity': '1'
	    }).stop().animate({
	      'opacity': '0'
	    }, 300, 'easeOutQuart', function () {
	      $('#movie-Stage').css({
	        'display': 'none'
	      });
	      $content.children('iframe').remove();
	    }); //
	    // $modal.stop().fadeOut(300, function(){
	    //   $content.children('iframe').remove();
	    // });
	  });
	}; // showTtl
	
	
	exports.showMovie = showMovie;
	
	var showTtl = function showTtl() {
	  var targetPositionAdd;
	
	  if (windowW >= 768) {
	    targetPositionAdd = 80;
	  } else {
	    targetPositionAdd = 20;
	  }
	
	  var scrollPosition = $(window).scrollTop();
	  $(window).on('load', function () {
	    setTimeout(function () {
	      $('.st-Container_Inner_Sub').addClass("show");
	    }, 10);
	    setTimeout(function () {
	      showTxt();
	    }, 300);
	  });
	
	  function showTxt() {
	    var footerPosition = $('#st-Footer').offset().top; //ファーストビュー内にあるタイトル
	
	    $('.sw-Ttl, .index-Anime').each(function () {
	      var targetPosition = $(this).offset().top;
	
	      if (targetPosition < windowH + scrollPosition) {
	        $(this).addClass("show");
	      }
	    }); //footer
	
	    if (footerPosition < windowH + scrollPosition) {
	      setTimeout(function () {
	        $('#st-Footer_Copy_Txt-0').removeClass("hidden");
	      }, 10);
	      setTimeout(function () {
	        $('#st-Footer_Copy_Txt-1').removeClass("hidden");
	      }, 300);
	      setTimeout(function () {
	        $('#st-Footer_Copy_Star').removeClass("hidden");
	      }, 500);
	    }
	
	    ; //ファーストビューより下にあるタイトル（スクロールで表示）
	
	    $(window).on('scroll', function () {
	      scrollPosition = $(window).scrollTop();
	      $('.sw-Ttl, .index-Anime').each(function () {
	        var targetPosition = $(this).offset().top;
	
	        if (scrollPosition > targetPosition - windowH + targetPositionAdd) {
	          $(this).addClass("show");
	        }
	      }); //footer
	
	      if (scrollPosition > footerPosition - windowH + 200) {
	        setTimeout(function () {
	          $('#st-Footer_Copy_Txt-0').removeClass("hidden");
	        }, 10);
	        setTimeout(function () {
	          $('#st-Footer_Copy_Txt-1').removeClass("hidden");
	        }, 300);
	        setTimeout(function () {
	          $('#st-Footer_Copy_Star').removeClass("hidden");
	        }, 500);
	      }
	
	      ;
	    });
	  }
	
	  ;
	};
	
	exports.showTtl = showTtl;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// index/app.bundle.js